// src/services/GoalService.ts

import { BaseService } from "@services/BaseService";
import { GoalPayload } from "@shared/interfaces/ProgramFiles";

class GoalService extends BaseService {
  createGoal(data: GoalPayload) {
    return this.post("/programs/goals", data);
  }

  getGoalById(goalId: string | number) {
    return this.get(`/programs/goals/${goalId}`);
  }

  updateGoal(goalId: string | number, data: Partial<GoalPayload>) {
    return this.patch(`/programs/goals/${goalId}`, data);
  }

  deleteGoal(goalId: string | number) {
    return this.delete(`/programs/goals/${goalId}`);
  }

  getGoalsByProgram(
    programId: string | number,
    params?: { order?: string; offset?: number; limit?: number }
  ) {
    return this.get(`/programs/${programId}/goals`, { params });
  }

  getProjectsInGoalsByProgram(
    programId: string | number,
    params?: { order?: string; offset?: number; limit?: number }
  ) {
    return this.get(`/programs/${programId}/goal-projects`, { params });
  }

  getGoalsDropdown(programId: string | number) {
    return this.get(`/programs/${programId}/goals/dropdown`);
  }
}

export const goalService = new GoalService();
